// removed by extract-text-webpack-plugin
module.exports = {"label":"ugXvW","light":"_1GkEd","dark":"tZuUg"};


//////////////////
// WEBPACK FOOTER
// ../src/components/Label/Label.css
// module id = 512
// module chunks = 0